export default __webpack_public_path__ + "static/media/calculator.011f5b2b.svg";